module.exports = __webpack_public_path__ + "img/DAVID_CANNON_11-rs.d4e5f20c.jpg";